// === GENERATED FILE ===
// DO NOT EDIT DIRECTLY, EDIT sh-list-item.lit.scss INSTEAD!
import { css } from 'lit';
export default css`/* Pressed state (mouse/touch) - background color for interactive items */
:root,
[sh-scale=s] {
  /* 
   * @cssprop [--sh-list-item-padding=0.25rem 1rem] - padding of the list item
   */
  --sh-list-item-padding: 0.25rem 1rem;
  /* 
   * @cssprop [--sh-list-item-min-height=2rem] - min height of the list item
   */
  --sh-list-item-min-height: 2rem;
  /* 
   * @cssprop [--sh-list-item-icon-margin=0.5rem] - margin of the icon and the arrow icon
   */
  --sh-list-item-icon-margin: 0.5rem;
  /* 
   * @cssprop [--sh-list-item-line-height=1.25rem] - line height of the label
   */
  --sh-list-item-line-height: 1.25rem;
  /* 
   * @cssprop [--sh-list-item-info-line-height=1rem] - line height of the info
   */
  --sh-list-item-info-line-height: 1rem;
  /* 
   * @cssprop [--sh-list-item-text-padding=0.25rem 0] - top and bottom padding of the text content
   */
  --sh-list-item-text-padding: 0.25rem 0;
  /* 
   * @cssprop [--sh-list-item-arrow-right-margin=0.5rem] - margin of the arrow icon
   */
  --sh-list-item-arrow-right-margin: 0.5rem;
  /* 
   * @cssprop [--sh-list-item-text-wrapper-left-margin=0.5rem] - left margin of the text wrapper
   */
  --sh-list-item-text-wrapper-left-margin: 0.5rem;
  /* 
   * @cssprop [--sh-list-item-right-slotted-margin=0.5rem] - right margin of the text wrapper
   */
  --sh-list-item-right-slotted-margin: 0.5rem;
  /* 
   * @cssprop [--sh-list-item-select-margin-right=0.5rem] - margin right of the checkbox/radio button
   */
  --sh-list-item-select-margin-right: 0.5rem;
  /* 
   * @cssprop [--sh-list-item-icon-size-s=2rem] - size of the icon
   */
  --sh-list-item-icon-size-s: 2rem;
  /* 
   * @cssprop [--sh-list-item-bottom-first-margin=0.5rem] - first child margin in bottom slot
   */
  --sh-list-item-bottom-first-margin: 0.5rem;
  /* 
   * @cssprop [--sh-list-item-bottom-slot-margin=0.5rem] - bottom slotted child margins
   */
  --sh-list-item-bottom-slot-margin: 0.5rem;
  /* 
   * @cssprop [--sh-list-item-content-line-height=1.25rem] - line height for the direct content added
   */
  --sh-list-item-content-line-height: 1.25rem;
  /* 
   * @cssprop [--sh-list-item-checkbox-right=0rem] - checkbox right margin
   */
  --sh-list-item-checkbox-right: 0rem;
  /* 
   * @cssprop [--sh-list-item-select-wrapper-size=2rem] - select wrapper height and width
   */
  --sh-list-item-select-wrapper-size: 2rem;
  /* 
   * @cssprop [--sh-list-item-info-margin=0.125rem 0] - top and bottom margin of the info
   */
  --sh-list-item-info-margin: 0.125rem 0;
  /* 
   * @cssprop [--sh-list-item-left-slotted-margin=0.25rem] - right margin of the left slotted items
   */
  --sh-list-item-left-slotted-margin: 0.25rem;
  /* 
   * @cssprop [--sh-list-item-right-slotted-first-margin=0.5rem] - left margin of the first right slotted item
   */
  --sh-list-item-right-slotted-first-margin: 0.5rem;
  /* 
   * @cssprop [--sh-list-item-divider-inset-margin=1rem] - divider inset margin to the left or right
   */
  --sh-list-item-divider-inset-margin: 1rem;
}

:host {
  position: relative;
  --sh-checkbox-margin-right: var(--sh-list-item-checkbox-right);
  color: var(--text-primary);
  display: block;
  height: fit-content;
}

/* Focus */
:host(.focused) {
  outline: var(--focus-outline);
  outline-offset: -0.0625rem;
}

/* Interactive cursor */
:host(:not([disabled])[clickable]),
:host(:not([disabled])[toggle]),
:host(:not([disabled])[selectable]),
:host(:not([disabled])[href]) {
  cursor: pointer;
}

.outer-wrapper {
  min-height: var(--sh-list-item-min-height);
  font: var(--body-1);
  line-height: var(--sh-list-item-content-line-height);
  height: fit-content;
  padding: var(--sh-list-item-padding);
  display: flex;
  align-items: center;
  gap: var(--sh-list-item-text-wrapper-left-margin);
}

/* Hover states (mouse only) */
@media (hover: hover) and (pointer: fine) {
  /* Interactive hover */
  :host(:not([disabled])[clickable]:hover) .outer-wrapper,
  :host(:not([disabled])[toggle]:hover) .outer-wrapper,
  :host(:not([disabled])[selectable]:hover) .outer-wrapper,
  :host(:not([disabled])[href]:hover) .outer-wrapper {
    background: rgba(var(--ui-1), var(--opacity-7));
  }
  /* Non-interactive hover = no background */
  :host(:not([disabled]):not([clickable]):not([toggle]):not([selectable]):not([href]):hover) .outer-wrapper {
    background: transparent;
  }
  /* Divider hover non-interactive = neutral */
  /* Top border hover for interactive items only */
  /* Non-interactive items: no top border on hover */
  /* Prevent hover background and lighter divider for already activated items */
}
@media (hover: hover) and (pointer: fine) and (hover: hover) and (pointer: fine) {
  /* Divider hover interactive = lighter */
  :host(:not([disabled])[clickable]:hover) .divider-wrapper,
  :host(:not([disabled])[toggle]:hover) .divider-wrapper,
  :host(:not([disabled])[selectable]:hover) .divider-wrapper,
  :host(:not([disabled])[href]:hover) .divider-wrapper {
    border-color: rgba(var(--ui-9), var(--opacity-1));
    right: 0;
    left: 0;
  }
}
@media (hover: hover) and (pointer: fine) {
  :host(:not([clickable]):not([toggle]):not([selectable]):not([href]):hover) .divider-wrapper {
    border-color: rgba(var(--ui-1), var(--opacity-6));
  }
  :host(:not([disabled])[clickable]:hover)::before,
  :host(:not([disabled])[toggle]:hover)::before,
  :host(:not([disabled])[selectable]:hover)::before,
  :host(:not([disabled])[href]:hover)::before {
    content: "";
    position: absolute;
    top: -0.0625rem;
    left: 0;
    right: 0; /* fill gap */
    width: 100%;
    height: 0.0625rem;
    background-color: rgba(var(--ui-9), var(--opacity-1));
  }
  :host(:not([clickable]):not([toggle]):not([selectable]):not([href]):hover)::before {
    content: none;
    background-color: transparent;
  }
  :host([active]:not([disabled]):hover) .outer-wrapper {
    background: rgba(var(--ui-1), var(--opacity-6));
  }
  :host([active]:not([disabled]):hover) .divider-wrapper {
    border-color: rgba(var(--divider), var(--opacity-1000));
  }
}
/* --- Active state --- */
:host([active]:not([disabled])) .outer-wrapper {
  background: rgba(var(--ui-1), var(--opacity-6));
}

:host([active][divider=full-width]:not([disabled])) .divider-wrapper {
  left: 0;
  right: 0;
  border-bottom: 1px solid rgba(var(--divider), var(--opacity-1000));
}

:host([active][divider=inset]:not([disabled])) .divider-wrapper {
  left: var(--sh-list-item-divider-inset-margin);
  right: var(--sh-list-item-divider-inset-margin);
  border-bottom: 1px solid rgba(var(--divider), var(--opacity-1000));
}

:host([active][divider=inset-left]:not([disabled])) .divider-wrapper {
  left: var(--sh-list-item-divider-inset-margin);
  right: 0;
  border-bottom: 1px solid rgba(var(--divider), var(--opacity-1000));
}

:host(:not([disabled]):not([divider=none])[active])::before {
  content: "";
  position: absolute;
  top: -0.0625rem;
  left: 0;
  right: 0; /* fill gap */
  width: 100%;
  height: 0.0625rem;
  background-color: rgba(var(--divider), var(--opacity-1000));
}

/* Reset when inactive */
:host(:not([active])) .divider-wrapper {
  border-color: rgba(var(--ui-1), var(--opacity-6));
}

:host(:not([active]))::before {
  background-color: transparent;
  content: none;
}

/* Strong top border */
:host(:not([disabled])[clickable]:active)::before,
:host(:not([disabled])[toggle]:active)::before,
:host(:not([disabled])[selectable]:active)::before,
:host(:not([disabled])[href]:active)::before {
  content: "";
  position: absolute;
  top: -0.0625rem;
  left: 0;
  right: 0; /* fill gap */
  width: 100%;
  height: 0.0625rem;
  background-color: rgba(var(--divider), var(--opacity-1000));
}

/* Strong bottom divider */
:host(:not([disabled])[clickable]:active)[divider=full-width] .divider-wrapper,
:host(:not([disabled])[toggle]:active)[divider=full-width] .divider-wrapper,
:host(:not([disabled])[selectable]:active)[divider=full-width] .divider-wrapper,
:host(:not([disabled])[href]:active)[divider=full-width] .divider-wrapper {
  left: 0;
  right: 0;
  border-bottom: 1px solid rgba(var(--divider), var(--opacity-1000));
}

:host(:not([disabled])[clickable]:active)[divider=inset] .divider-wrapper,
:host(:not([disabled])[toggle]:active)[divider=inset] .divider-wrapper,
:host(:not([disabled])[selectable]:active)[divider=inset] .divider-wrapper,
:host(:not([disabled])[href]:active)[divider=inset] .divider-wrapper {
  left: var(--sh-list-item-divider-inset-margin);
  right: var(--sh-list-item-divider-inset-margin);
  border-bottom: 1px solid rgba(var(--divider), var(--opacity-1000));
}

:host(:not([disabled])[clickable]:active)[divider=inset-left] .divider-wrapper,
:host(:not([disabled])[toggle]:active)[divider=inset-left] .divider-wrapper,
:host(:not([disabled])[selectable]:active)[divider=inset-left] .divider-wrapper,
:host(:not([disabled])[href]:active)[divider=inset-left] .divider-wrapper {
  left: var(--sh-list-item-divider-inset-margin);
  right: 0;
  border-bottom: 1px solid rgba(var(--divider), var(--opacity-1000));
}

/* Non-interactive pressed = no effect */
:host(:not([disabled]):not([clickable]):not([toggle]):not([selectable]):not([href]):active) .outer-wrapper {
  background: transparent;
}

:host(:not([disabled]):not([clickable]):not([toggle]):not([selectable]):not([href]):active) .divider-wrapper {
  border-color: rgba(var(--ui-1), var(--opacity-6));
}

/* Disabled */
:host([disabled]) {
  pointer-events: none;
}
:host([disabled]) .outer-wrapper {
  opacity: 0.2;
}

/* Slots, text, icons, etc. (unchanged) */
:host slot[name=left]::slotted(*) {
  margin-right: var(--sh-list-item-left-slotted-margin);
}

:host slot[name=right]::slotted(*:not(:first-child)) {
  margin-left: var(--sh-list-item-right-slotted-margin);
}

:host slot[name=right]::slotted(*:first-child) {
  margin-left: var(--sh-list-item-right-slotted-first-margin);
}

:host slot[name=bottom]::slotted(*:last-child) {
  margin-bottom: var(--sh-list-item-bottom-slot-margin);
}

:host slot[name=bottom]::slotted(*:not(:last-child)) {
  margin-bottom: var(--sh-list-item-bottom-first-margin);
}

.label {
  line-height: var(--sh-list-item-line-height);
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  -webkit-line-clamp: 1;
}

.info {
  line-height: var(--sh-list-item-info-line-height);
  margin: var(--sh-list-item-info-margin);
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  -webkit-line-clamp: 1;
}

:host(:not([label]):not([info])) .slot-body {
  display: flex;
  align-items: center;
  height: 100%;
}

.icon {
  margin-right: var(--sh-list-item-icon-margin);
  min-height: var(--sh-list-item-icon-size-s);
  min-width: var(--sh-list-item-icon-size-s);
}

.text-wrapper {
  flex: 1;
  padding: var(--sh-list-item-text-padding);
}

.icon-text-wrapper {
  display: flex;
  align-items: center;
}

.right-slot-wrapper {
  display: flex;
  padding: 0.25rem 0;
}

.right {
  display: flex;
}

.arrow {
  margin-left: var(--sh-list-item-icon-margin);
  margin-right: calc(-1 * var(--sh-list-item-arrow-right-margin));
}

.content-wrapper {
  flex: 1;
}

.select-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--sh-list-item-select-wrapper-size);
  height: var(--sh-list-item-select-wrapper-size);
}

:host([vertical-align=top]) .select-wrapper,
:host([vertical-align=top]) .arrow {
  align-self: flex-start;
}

:host([vertical-align=top]) .content-wrapper {
  margin-top: 0rem;
}

:host([divider=full-width]) .divider-wrapper {
  left: 0rem;
}

:host([divider=inset]) .divider-wrapper {
  left: var(--sh-list-item-divider-inset-margin);
  right: var(--sh-list-item-divider-inset-margin);
}

.select {
  width: fit-content;
}

.divider-wrapper {
  bottom: 0;
  left: var(--sh-list-item-divider-inset-margin);
  position: absolute;
  right: 0;
  border-bottom: 1px solid rgba(var(--ui-1), var(--opacity-6));
}

@media (hover: hover) and (pointer: fine) {
  :host(:not([disabled])[clickable]:hover) .divider-wrapper,
  :host(:not([disabled])[toggle]:hover) .divider-wrapper,
  :host(:not([disabled])[selectable]:hover) .divider-wrapper,
  :host(:not([disabled])[href]:hover) .divider-wrapper {
    left: 0;
    right: 0;
  }
}
/* --- Pressed (active) states --- */
:host(:not([disabled])[clickable]:active) .divider-wrapper,
:host(:not([disabled])[toggle]:active) .divider-wrapper,
:host(:not([disabled])[selectable]:active) .divider-wrapper,
:host(:not([disabled])[href]:active) .divider-wrapper {
  left: 0;
  right: 0;
  border-color: rgba(var(--divider), var(--opacity-1000));
}

:host([active][divider]:not([divider=none]):not([disabled])) .divider-wrapper {
  left: 0;
  right: 0;
  border-color: rgba(var(--divider), var(--opacity-1000));
}

/* Add this rule to set the STRONG border color */
:host([active]:not([disabled])) .divider-wrapper,
:host(:not([disabled])[clickable]:active) .divider-wrapper,
:host(:not([disabled])[toggle]:active) .divider-wrapper,
:host(:not([disabled])[selectable]:active) .divider-wrapper,
:host(:not([disabled])[href]:active) .divider-wrapper {
  border-color: rgba(var(--divider), var(--opacity-1000));
}

.draggable {
  margin-left: var(--sh-list-item-text-wrapper-left-margin);
}

/* Icons and controls */
sh-icon[icon=arrow-right-s] {
  opacity: var(--icon-idle-opacity);
}

:host(:not(.touch-device)) .outer-wrapper:hover sh-icon[icon=arrow-right-s] {
  opacity: var(--opacity-950);
}

sh-checkbox[readonly] {
  --sh-checkbox-readonly-opacity: var(--opacity-1);
  --sh-checkbox-readonly-unchecked-bg: transparent;
  --sh-checkbox-readonly-unchecked-border: rgba(var(--ui-1), var(--opacity-600));
  --sh-checkbox-readonly-checked-bg: rgba(var(--ui-2), var(--opacity-1000));
  --sh-checkbox-readonly-checked-border: transparent;
  --sh-checkbox-readonly-checked-bg-neutral: rgba(var(--ui-1), var(--opacity-700));
}

sh-radio-button[readonly] {
  --sh-radio-button-readonly-opacity: var(--opacity-1);
  --sh-radio-button-readonly-unchecked-bg: transparent;
  --sh-radio-button-readonly-checked-border-color: rgba(var(--ui-2), var(--opacity-1000));
}

:host(:not([disabled])[clickable]:active) .outer-wrapper,
:host(:not([disabled])[toggle]:active) .outer-wrapper,
:host(:not([disabled])[selectable]:active) .outer-wrapper,
:host(:not([disabled])[href]:active) .outer-wrapper {
  background: rgba(var(--ui-1), var(--opacity-6));
}`;